import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, OutlinedInput, Typography, useMediaQuery } from '@mui/material';
import Modal from '@mui/material/Modal';
import { useFormik } from 'formik';
import React from 'react';
import { sxFormError, sxLabel } from '../../assets/styles/CommonSxProps';
import { EmailValidation } from '../../interfaces/validation/EmailValidation';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import DefaultButton from '../Accessibility/DefaultButton';
import WhiteContainer from '../Accessibility/WhiteContainer';
import './styles.css';
import { sxButton, sxButtonContained, sxInputEmailModal, sxTypographyTitle } from './sxProps';


const ModalNewEmail: React.FC<{
  showModal: boolean,
  handleShowModal: () => void,
  handleAddEmail: (email: string) => void
}> = ({ showModal, handleShowModal, handleAddEmail }) => {

  const { textStyleAccessibility } = useAccessibility();

  const mobileScreen = useMediaQuery('(max-width: 899px)');

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: EmailValidation,
    onSubmit: (values) => {
      handleAddEmail(values.email);
      formik.resetForm();
    },
    validateOnChange: false
  });

  const closeModal = () => {
    handleShowModal();
    formik.resetForm();
  }

  const containedButton = (
    <DefaultButton
      type='submit'
      sx={sxButtonContained}
      text='Salvar'
      variant={'contained'}
    />
  );

  const outlinedButton = (
    <DefaultButton
      onClick={closeModal}
      sx={sxButton}
      variant='outlined'
    >
      <Typography style={{color: '#00995D'}}>Cancelar</Typography>
    </DefaultButton>
  );


  return (
    <div>
      {showModal && <Modal
        open={showModal}
        onClose={closeModal}
      >
        <form onSubmit={formik.handleSubmit}>
        <WhiteContainer className='container-modal-new-email'>
          <div className='modal-new-email-header'>
            <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitle}>Cadastrar novo e-mail</Typography>
            <IconButton
              aria-label="fechar"
              onClick={closeModal}
            >
              <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
            </IconButton>
          </div>
          <Box display={'flex'} flexDirection={'column'} width={'100%'} >
            <Typography style={textStyleAccessibility} sx={sxLabel}>E-mail</Typography>
            <label htmlFor='email' aria-label='email' />
            <OutlinedInput
              placeholder='email@email.com'
              id='email'
              type={'email'}
              value={formik.values.email}
              onChange={(e) => { formik.setFieldValue('email', e.target.value); }}
              name='email'
              style={textStyleAccessibility}
              error={!!formik.errors.email}
              maxRows={1}
              inputProps={{ maxLength: 100 }}
              sx={sxInputEmailModal}
            />
            <Typography style={textStyleAccessibility} sx={sxFormError}>{formik.errors.email}</Typography>
          </Box>
          <div className='email-modal-buttons-holder'>
            {mobileScreen ? containedButton : outlinedButton}
            {mobileScreen ? outlinedButton : containedButton}
          </div>
        </WhiteContainer>
        </form>
      </Modal>}
    </div>
  );
};

export default ModalNewEmail;
